import { render } from "./Header.vue?vue&type=template&id=61dd7a3d&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=61dd7a3d&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dd7a3d"],['__file',"src/components/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61dd7a3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61dd7a3d', __exports__)) {
    console.log('reload')
    api.reload('61dd7a3d', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=61dd7a3d&scoped=true", () => {
    console.log('re-render')
    api.rerender('61dd7a3d', render)
  })

}


export default __exports__